import { render, staticRenderFns } from "./AreaModal.vue?vue&type=template&id=bc8d2c9a"
import script from "./AreaModal.vue?vue&type=script&lang=js"
export * from "./AreaModal.vue?vue&type=script&lang=js"
import style0 from "./AreaModal.vue?vue&type=style&index=0&id=bc8d2c9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports